import { useEffect } from "react";
import { useInstantSearch } from "react-instantsearch";

function ResultsLogger({ label }) {
  const { results } = useInstantSearch();

  useEffect(() => {
    if (!results?.params) return;
    console.log(`[Algolia ${label}]`, {
      index: results.index,
      query: results.query,
      params: results.params,
      nbHits: results.nbHits,
      page: results.page,
      nbPages: results.nbPages,
      hits: results.hits,
      facets: results.facets,
    });
  }, [results, label]);

  return null;
}

export function LogAlgoliaResults({ label, logInProduction = false }) {
  return logInProduction || process.env.REACT_APP_ENV !== "1" ? <ResultsLogger label={label} /> : null;
}
